import * as _ from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";

import {
  Text,
  TextTruncate
} from "src/library/components/Text";
import BrandedImage from "src/core/shared/components/BrandedImage";
import { IProduct } from "src/core/products/api/products.api";

import { SearchRowProps } from "./ProductSearchComponent";

// Not sure why Omit didn't work...
type SearchPropsType = Pick<SearchRowProps, Exclude<keyof SearchRowProps, "product" | "highlighted" | "disabled">>;

interface Props {
  product: IProduct;
  highlighted: boolean;
  disabled: boolean;
  searchProps: SearchPropsType;
  onProductSelect: (product: IProduct | null, quantity: number) => void;
  setIsOpen: (open: boolean) => void;
}

export const OrdersTableProductSelectItem: React.ReactFCWithChildren<Props> = ({
  onProductSelect,
  product,
  highlighted,
  disabled,
  searchProps,
  setIsOpen
}) => {
  return (
    // @ts-ignore
    <DropdownItem
      // @ts-ignore
      onClick={() => {
        setIsOpen(false);
        onProductSelect(product, 1);
      }}
      highlighted={highlighted}
      disabled={disabled}
      product={product}
      {...searchProps}
    >
      <div className={`${!product.image && "no-image"} product-image-wrapper`}>
        <BrandedImage
          alt={product.description}
          level="public"
          s3Key={product.image}
        />
      </div>

      <div className="product-details">
        <TextTruncate
          className="description"
          fontSize="h3"
          truncateProps={{ lines: 3 }}
        >
          {product.description}
        </TextTruncate>

        <br />

        <Text
          color={highlighted ? "white" : "secondary"}
          weight="bold"
          textTransform="uppercase"
          letterSpacing="big"
          className="part-number"
        >
          {product.partNumber}
        </Text>
      </div>
    </DropdownItem>
  );
};

const DropdownItem = styled.div<SearchRowProps>`
  ${({
    theme, highlighted, disabled
  }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background: ${disabled ? theme.colors.lightGrey : highlighted ? theme.colors.primaryDark : "white"};
    color: ${disabled || highlighted ? "white" : theme.colors.primaryDark};
    pointer-events: ${disabled ? "none" : "all"};
    padding: ${theme.spacing.padding.sm};
    width: 100%;
    border-top: ${theme.colors.lightestGrey} 1px solid;
    height: 100px;
    cursor: pointer;

    .product-image-wrapper {
      position: relative;
      height: 50px;
      width: 50px;
      margin-right: ${theme.spacing.margins.md};

      .no-image {
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${theme.colors.lightGrey};
        padding: ${theme.spacing.padding.sm};
      }
    }

    .add-to-order {
      width: 200px;
    }

    .product-details {
      width: 250px;
    }

    ${highlighted &&
      `
      .description {
        color: ${theme.colors.white};
      }
      .current-price-wrapper span {
        color: ${theme.colors.white};
      }
    `}
  `}
`;
